import { motion } from "framer-motion";
import { Users, Snowflake, Armchair, MapPin } from "lucide-react";

const vehicles = [
  {
    src: "/assets/628.png",
    name: "Omnibus 628",
    type: "DOBLE PISO - MIX",
    pax: "60 Pax",
    features: ["Butacas Cama y Semicama", "AA y Calefaccion", "Monitoreo por GPS"],
  },
  {
    src: "/assets/626.jpeg",
    name: "Omnibus 626",
    type: "DOBLE PISO - MIX",
    pax: "60 Pax",
    features: ["Butacas Cama y Semicama", "AA y Calefaccion", "Monitoreo por GPS"],
  },
  {
    src: "/assets/625.jpeg",
    name: "Omnibus 625",
    type: "DOBLE PISO - MIX",
    pax: "60 Pax",
    features: ["Butacas Cama y Semicama", "AA y Calefaccion", "Monitoreo por GPS"],
  },
  {
    src: "/assets/622.jpeg",
    name: "Omnibus 622",
    type: "DOBLE PISO - MIX",
    pax: "60 Pax",
    features: ["Butacas Cama y Semicama", "AA y Calefaccion", "Monitoreo por GPS"],
  },
  {
    src: "/assets/619.jpeg",
    name: "Omnibus 619",
    type: "DOBLE PISO - SEMICAMA",
    pax: "60 Pax",
    features: ["Butacas Semicama", "AA y Calefaccion", "Monitoreo por GPS"],
  },
  {
    src: "/assets/618.jpg",
    name: "Omnibus 618",
    type: "DOBLE PISO - SEMICAMA",
    pax: "60 Pax",
    features: ["Butacas Semicama", "AA y Calefaccion", "Monitoreo por GPS"],
  },
  {
    src: "/assets/616.jpeg",
    name: "Omnibus 616",
    type: "DOBLE PISO - SEMICAMA",
    pax: "60 Pax",
    features: ["Butacas Semicama", "AA y Calefaccion", "Monitoreo por GPS"],
  },
  {
    src: "/assets/615.jpeg",
    name: "Omnibus 615",
    type: "DOBLE PISO - MIX",
    pax: "60 Pax",
    features: ["Butacas Cama y Semicama", "AA y Calefaccion", "Monitoreo por GPS"],
  },
  {
    src: "/assets/h1-7pasaj.jpeg",
    name: "Minivan",
    type: "EJECUTIVA",
    pax: "7 Pax",
    features: ["Asientos premium", "AA y Calefaccion", "Monitoreo por GPS"],
  },
  {
    src: "/assets/minibus-19pas.jpeg",
    name: "Minibus Sprinter",
    type: "COMBI",
    pax: "19 Pax",
    features: ["Asientos reclinables", "AA y Calefaccion", "Monitoreo por GPS"],
  },
];

const containerVariants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.12 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

export default function Flota() {
  return (
    <section
      id="flota"
      className="py-20 md:py-32 bg-[#080f1c]"
      data-testid="flota-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-6"
        >
          <span className="text-[#3DD9E8] text-sm font-bold uppercase tracking-[0.3em] font-body">
            Nuestra flota
          </span>
          <h2 className="font-heading text-4xl md:text-6xl text-white uppercase tracking-tight mt-3">
            Vehiculos de confianza
          </h2>
          <p className="text-gray-400 font-body text-base md:text-lg mt-4 max-w-2xl">
            Tambien contamos con SUV blindadas y buses ejecutivos para traslados protocolares. <span className="text-[#D0162A] font-semibold">Disponibles bajo pedido.</span>
          </p>
        </motion.div>

        {/* Interior showcase */}
        <motion.div
          className="mb-12 relative overflow-hidden group cursor-pointer"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          data-testid="fleet-interior-showcase"
        >
          <img
            src="/assets/butacas.jpeg"
            alt="Interior premium con butacas reclinables"
            className="w-full h-[280px] md:h-[350px] object-cover transition-transform duration-500 group-hover:scale-[1.02]"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#080f1c]/90 via-[#080f1c]/40 to-transparent flex items-center">
            <div className="px-8 md:px-14">
              <h3 className="font-heading text-3xl md:text-4xl text-white uppercase tracking-wide">
                Interior Premium
              </h3>
              <p className="text-gray-300 font-body text-sm md:text-base mt-2 max-w-md">
                Butacas cama y semicama totalmente reclinables, iluminacion LED, aire acondicionado y calefaccion en toda la flota.
              </p>
              <div className="flex flex-wrap gap-4 mt-4">
                <span className="flex items-center gap-2 text-[#3DD9E8] text-xs font-bold uppercase tracking-wider">
                  <Armchair size={16} /> Butacas Cama
                </span>
                <span className="flex items-center gap-2 text-[#3DD9E8] text-xs font-bold uppercase tracking-wider">
                  <Snowflake size={16} /> AA y Calefaccion
                </span>
                <span className="flex items-center gap-2 text-[#3DD9E8] text-xs font-bold uppercase tracking-wider">
                  <MapPin size={16} /> GPS
                </span>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Vehicle cards grid */}
        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 gap-6"
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          {vehicles.map((v, i) => (
            <motion.div
              key={i}
              className="group bg-[#151e32] border border-white/5 hover:border-[#3DD9E8]/30 overflow-hidden flex flex-col sm:flex-row transition-all duration-300"
              variants={itemVariants}
              data-testid={`fleet-card-${i}`}
            >
              {/* Image */}
              <div className="sm:w-[45%] flex-shrink-0 overflow-hidden">
                <img
                  src={v.src}
                  alt={v.name}
                  className="w-full h-[200px] sm:h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>

              {/* Info */}
              <div className="flex-1 p-5 md:p-6 flex flex-col justify-between">
                <div>
                  <h3 className="font-heading text-xl md:text-2xl text-white uppercase tracking-wide">
                    {v.name}
                  </h3>
                  <div className="w-12 h-[2px] bg-[#D0162A] mt-2 mb-3" />

                  {/* Pax */}
                  <div className="flex items-center gap-2 mb-3">
                    <Users className="text-[#3DD9E8]" size={18} />
                    <span className="text-white font-body font-semibold text-sm">
                      {v.pax}
                    </span>
                  </div>

                  {/* Type badge */}
                  <span className="inline-block bg-[#1B3A8C]/30 text-[#3DD9E8] text-xs font-bold uppercase tracking-wider px-3 py-1 mb-4">
                    {v.type}
                  </span>

                  {/* Features */}
                  <ul className="space-y-1.5">
                    {v.features.map((f, fi) => (
                      <li key={fi} className="text-gray-400 font-body text-sm flex items-center gap-2">
                        <span className="w-1.5 h-1.5 bg-[#D0162A] inline-block flex-shrink-0" />
                        {f}
                      </li>
                    ))}
                  </ul>
                </div>

                {/* CTA */}
                <a
                  href="#contacto"
                  className="inline-flex items-center gap-2 text-[#3DD9E8] text-xs font-bold uppercase tracking-wider mt-4 hover:text-white transition-colors duration-200"
                  data-testid={`fleet-cta-${i}`}
                >
                  Consultar
                  <span className="w-4 h-4 border border-[#3DD9E8] flex items-center justify-center group-hover:bg-[#3DD9E8] group-hover:text-[#080f1c] transition-colors duration-200">
                    &rarr;
                  </span>
                </a>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
